import { trackCtaClicked, detectIOS } from '@zola-helpers/client';

export type trackAppButtonClickParams = {
  businessUnit?: string;
  deepLink?: string;
  location: string;
  section: string;
};

function trackAppButtonClick({
  businessUnit,
  deepLink,
  location,
  section,
}: trackAppButtonClickParams): void {
  const cta = detectIOS() ? 'Download on the App Store' : 'Get it on Google Play';
  const fallbackId = detectIOS()
    ? 'https://itunes.apple.com/us/app/zola-wedding-registry-gifts/id852691916'
    : 'https://play.google.com/store/apps/details?id=com.zola.android.wedding&hl=en';

  const ctaId = deepLink || fallbackId;
  trackCtaClicked({
    business_unit: businessUnit,
    cta_type: 'DEEP_LINK',
    cta_id: ctaId,
    position: 1,
    location,
    section,
    cta,
  });
}

export default trackAppButtonClick;



// WEBPACK FOOTER //
// ./src/pages/postOnboard/AppDownload/appDownloadTracking.ts